import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { FaTrash, FaPlus } from "react-icons/fa";
import { ENV } from "../../config/config";
import validator from "validator";
import { useCreateDonutMutation } from "../../redux/api";

const SpendingChartForm = ({ donut, permissions, setDonut }) => {
  const [createDonutMut, { isLoading: isDonutCreating }] = useCreateDonutMutation();
  const [msg, setMsg] = useState({});

  const submit = () => {
    let check = true;
    const newMsg = { ...msg };
    donut.forEach((item, index) => {
      if (validator.isEmpty(item.label)) {
        newMsg[`label${index}`] = "Label is required";
        check = false;
      }
      if (validator.isEmpty(item.data)) {
        newMsg[`data${index}`] = "Data is required";
        check = false;
      }
      if (validator.isEmpty(item.color)) {
        newMsg[`color${index}`] = "Color is required";
        check = false;
      }
    });
    if (!check) {
      setMsg(newMsg);
      return;
    }
    if (check) {
      (async () => {
        await createDonutMut(donut);
        setDonut([{ label: "", data: "", color: "" }]);
        setMsg({});
      })();
    }
  };

  // Function to handle changes in input fields
  const handleChange = (index, field, value) => {
    const newLinks = [...donut];
    newLinks[index][field] = value;
    setDonut(newLinks);
  };

  // Function to add a new empty field
  const handleAddField = () => {
    setDonut([...donut, { label: "", data: "", color: "" }]);
  };

  // Function to remove a field
  const handleRemoveField = (index) => {
    const newLinks = [...donut];
    newLinks.splice(index, 1);
    setDonut(newLinks);
  };
  return (
    <>
      {isDonutCreating && <FullPageLoader />}
      <Container fluid>
      <Row>
        <Col md="12">
          <Form
            action=""
            className="form-horizontal"
            id="TypeValidation"
            method=""
          >
            <Card className="table-big-boy p-5">
              {/* CHART */}
              <Card className="table-big-boy mb-5">
                <Card.Header>
                  <div className="d-block d-md-flex align-items-center justify-content-between">
                    <Card.Title as="h4">Spending Chart Setting</Card.Title>
                  </div>
                </Card.Header>

                <Card.Body>
                  {donut &&
                    donut.map((don, index) => (
                      <Row key={index}>
                        <Col xl={4} md={6}>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Label
                            </Form.Label>
                            <Form.Control
                              className={msg[`label${index}`] ? "on-error" : ""}
                              type="text"
                              value={don.label}
                              onChange={(e) =>
                                handleChange(index, "label", e.target.value)
                              }
                            />
                          </Form.Group>
                          <span
                            className={
                              msg[`label${index}`] ? "text-danger" : "d-none"
                            }
                          >
                            {msg[`label${index}`]}
                          </span>
                        </Col>
                        <Col xl={4} md={6}>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Number
                            </Form.Label>
                            <Form.Control
                              className={msg[`data${index}`] ? "on-error" : ""}
                              type="number"
                              value={don.data}
                              onKeyDown={(e) => ENV.integerNumberValidator(e)}
                              onChange={(e) =>
                                handleChange(index, "data", e.target.value)
                              }
                            />
                          </Form.Group>
                          <span
                            className={
                              msg[`data${index}`] ? "text-danger" : "d-none"
                            }
                          >
                            {msg[`data${index}`]}
                          </span>
                        </Col>
                        <Col xl={4} md={6}>
                          <Form.Group>
                            <Form.Label className="d-block mb-2">
                              Color
                            </Form.Label>
                            <Row className="d-flex align-items-center">
                              <Col xs={4}>
                                <Form.Control
                                  className={
                                    msg[`color${index}`] ? "on-error" : ""
                                  }
                                  type="color"
                                  value={don.color}
                                  onChange={(e) =>
                                    handleChange(index, "color", e.target.value)
                                  }
                                />
                              </Col>
                              {index > 0 && (
                                <Button
                                  variant="danger"
                                  onClick={() => handleRemoveField(index)}
                                  className="ml-2"
                                  style={{ margin: 0 }}
                                >
                                  <FaTrash />
                                </Button>
                              )}
                            </Row>
                            <span
                              className={
                                msg[`color${index}`] ? "text-danger" : "d-none"
                              }
                            >
                              {msg[`color${index}`]}
                            </span>
                          </Form.Group>
                        </Col>
                      </Row>
                    ))}
                  <Button
                    variant="primary"
                    className="btn-filled"
                    onClick={handleAddField}
                  >
                    <FaPlus />
                  </Button>
                </Card.Body>
              </Card>
              <hr className="centered-hr" />

              <Card.Footer>
                <Row className="float-right">
                  {permissions && permissions.editSetting && (
                    <Col sm={12} className="d-flex">
                      <Button className="btn-filled mt-3" onClick={submit}>
                        Save
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Footer>
            </Card>
          </Form>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default SpendingChartForm;
